import { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { formatApiError } from "../lib/api";
import { ArrowRight } from "@phosphor-icons/react";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const expired = params.get("expired") === "1";
  const next = params.get("next") || "/admin";
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setSubmitting(true);
    try {
      await login(email, password);
      navigate(next);
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail) || "Login failed");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div data-testid="login-page" className="flex min-h-[80vh] items-center justify-center px-6 py-16">
      <div className="w-full max-w-md border border-white/10 bg-[#0a0a0a] p-10">
        <div className="text-xs font-bold uppercase tracking-[0.2em] text-[#D4FF00]">Editorial Access</div>
        <h1 className="mt-2 font-display text-4xl font-bold tracking-tighter text-white">Admin Login</h1>
        <p className="mt-3 text-sm text-white/60">Sign in to publish articles, podcasts, and digital content.</p>

        {expired && (
          <div data-testid="login-expired" className="mt-6 border border-[#D4FF00]/40 bg-[#D4FF00]/5 px-4 py-3 text-xs uppercase tracking-[0.15em] text-[#D4FF00]">
            Your session expired — please sign in again.
          </div>
        )}

        <form onSubmit={submit} className="mt-8 space-y-5">
          <div>
            <label className="text-[10px] font-bold uppercase tracking-[0.2em] text-white/60">Email</label>
            <input
              data-testid="login-email"
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="mt-2 w-full border border-white/15 bg-black px-4 py-3 text-white outline-none focus:border-[#D4FF00]"
            />
          </div>
          <div>
            <label className="text-[10px] font-bold uppercase tracking-[0.2em] text-white/60">Password</label>
            <input
              data-testid="login-password"
              type="password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="mt-2 w-full border border-white/15 bg-black px-4 py-3 text-white outline-none focus:border-[#D4FF00]"
            />
          </div>
          {error && <div data-testid="login-error" className="text-xs uppercase tracking-[0.2em] text-red-400">{error}</div>}
          <button
            data-testid="login-submit"
            type="submit"
            disabled={submitting}
            className="flex w-full items-center justify-center gap-2 bg-[#D4FF00] px-6 py-4 text-xs font-bold uppercase tracking-[0.2em] text-black transition-transform hover:-translate-y-0.5 disabled:opacity-50"
          >
            {submitting ? "Signing in…" : "Sign In"} <ArrowRight size={14} weight="bold" />
          </button>
        </form>
      </div>
    </div>
  );
}
